import * as _ from 'lodash'
import util from './util';
import serviceGateway from './serviceGateway';
import store from './store';
import * as globalActions from './actions';
import messageModel from './models/messageModel';
import socketClient from './socketClient';

// TODO: only monitor 'active' channels as determined by view state? or a list here of previously fetched channels?

function processMessageResult (messages) {
	const model = store().get('model');

	model.withMutations(map => {
		_.forEach(messages, m => {
			const existing = map.getIn(['messages', m.key]);

			if (!existing || !existing.itemVersion || existing.itemVersion <= m.itemVersion) {
				map.setIn(['messages', m.key], messageModel(m));
			}
		});
	});
}

export const socketClientHandlers = {
	['model.message.added']: message => {
		const channels = store().getIn(['viewState', 'watchedChannels']);

		if (channels.includes(message.payload.messageChannelKey)) {
			fetchMessage({ key: message.payload.key });
		}
	},
	['model.message.removed']: message => {
		store().deleteIn(['model', 'messages', message.payload.key]);
	}
};

// wrap handlers to allow extensions to override
for (const key of _.keys(socketClientHandlers)) {
	socketClient.on(key, message => {
		socketClientHandlers[key](message);
	});
}

// NOTE: Action returns are only to allow tests to access the promise. DO NOT use return values in runtime code.
export const fetchMessage = params => {
	return serviceGateway.fetchMessage(params)
		.then(result => {
			if (result.message) {
				processMessageResult([result.message]);
			}
		})
		.catch(err => {
			globalActions.pushAlert({ type: 'warning', message: err.message || err, isCloseable: true });
		});
};

export const fetchMessages = params => {
	return serviceGateway.fetchMessages(params)
		.then(result => {
			processMessageResult(result.messages);
		})
		.catch(err => {
			globalActions.pushAlert({ type: 'warning', message: err.message || err, isCloseable: true });
		});
};

export const saveMessage = params => {
	const keyPath = ['model', 'messages', params.message.key];

	store().setIn(keyPath, messageModel(params.message));
	return serviceGateway.saveMessage({ message: params.message, patch: params.message.dateCreated ? params.patch : undefined })
		.then(result => {
			processMessageResult([result.message]);
		})
		.catch(err => {
			const key = util.generateGuid();
			const retry = p => {
				globalActions.clearAlert({ key: key });
				return saveMessage(p || params);
			};

			globalActions.pushAlert({
				key: key,
				type: 'error',
				message: err.message || 'Server Error',
				source: 'server',
				action: 'saveMessage',
				retry: retry,
				params: params,
				orgininalError: err,
				isCloseable: true
			});
		});
};

export const deleteMessage = params => {
	const keyPath = ['model', 'messages', params.message.key];

	store().deleteIn(keyPath);
	return serviceGateway.deleteMessage(params)
		.catch(err => {
			store().setIn(keyPath.slice(1), params.message);
			globalActions.pushAlert({ type: 'warning', message: err.message || err, isCloseable: true });
		});
};

export const watchChannel = params => {
	const channels = store().getIn(['viewState', 'watchedChannels']);

	if (!channels.includes(params.channel)) {
		store().getIn(['viewState', 'watchedChannels']).push(params.channel);
	}
};

export const unwatchChannel = params => {
	const channels = store().getIn(['viewState', 'watchedChannels']);
	// filter is a Lazy function, toList forces it to execute
	const filtered = channels.filter(c => {
		return c !== params.channel;
	}).toList();

	store().setIn(['viewState', 'watchedChannels'], filtered);
};